import { queryKeys } from './useQueryPreferences'
import { useFetchPreferences } from './useFetchPreferences'
import { useQueryClientUtils } from '../useQueryClientUtils'

const upsertByKey = () => {
  const { upsertByKey } = useFetchPreferences()
  const { cancelQueries, invalidateQueries } = useQueryClientUtils()

  return useMutation({
    mutationFn: upsertByKey,
    onMutate: ({ payload }) => {
      cancelQueries([queryKeys.getByKey({ key: payload.key }).queryKey])
    },
    onSettled: (_, _1, { payload }) => {
      invalidateQueries([queryKeys.getByKey({ key: payload.key }).queryKey])
    },
  })
}

const dropByKey = () => {
  const { dropByKey } = useFetchPreferences()
  const { cancelQueries, invalidateQueries } = useQueryClientUtils()

  return useMutation({
    mutationFn: dropByKey,
    onMutate: ({ key }) => {
      cancelQueries([queryKeys.getByKey({ key }).queryKey])
    },
    onSettled: (_, _1, { key }) => {
      invalidateQueries([queryKeys.getByKey({ key }).queryKey])
    },
  })
}

export const useMutationPreferences = {
  upsertByKey,
  dropByKey,
}
